import { render } from "./mhead&mlogin.vue?vue&type=template&id=5db2a9d7&scoped=true"
import script from "./mhead&mlogin.vue?vue&type=script&lang=js"
export * from "./mhead&mlogin.vue?vue&type=script&lang=js"

import "./mhead&mlogin.vue?vue&type=style&index=0&id=5db2a9d7&lang=less&scoped=true"

import exportComponent from "E:\\ekt.pro.git\\new-ekt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db2a9d7"]])

export default __exports__